import { stepProgress } from '../../animations/gsapAnimations'
import { useGsapContext } from '../../hooks/useGsapReveal'

const STEPS = [
  {
    title: 'Choose your vehicle',
    body: 'Pick from floor stock or name the variant and colour you want sourced.',
  },
  {
    title: 'Calculate your lease',
    body: 'Set the down payment and tenure until the monthly number works.',
  },
  {
    title: 'Submit your application',
    body: 'One set of documents. We prepare the file and check it before it goes.',
  },
  {
    title: 'Bank review',
    body: 'Every partner bank assesses the same file at the same time.',
  },
  {
    title: 'Approval',
    body: 'Offers come back side by side. You choose the markup and the tenure.',
  },
  {
    title: 'Drive away',
    body: 'Registration, tracker and insurance handled. Keys in your hand.',
  },
] as const

/* The horizontal treatment of the six steps. The home page carries the same
   journey as a vertical rail, where long-form prose reads better; here the
   copy is short enough to sit across the page. */
function FinancingSteps() {
  const track = useGsapContext<HTMLDivElement>((scope) => stepProgress(scope, 'x'))

  return (
    <div ref={track} className="relative">
      {/* The rail the scroll draws left to right, behind the numerals. */}
      <div
        aria-hidden="true"
        className="absolute top-[21px] right-0 left-0 hidden h-px bg-line lg:block"
      >
        <span
          data-progress-line
          className="block h-full w-full origin-left bg-lime"
        />
      </div>

      <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-6 lg:gap-6">
        {STEPS.map((step, index) => (
          <li key={step.title} data-progress-step className="relative">
            <span
              aria-hidden="true"
              className="grid size-11 place-items-center rounded-full border border-lime/40 bg-raised text-[12px] font-medium text-lime-deep tabular-nums"
            >
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-5 font-display text-[16.5px] font-semibold tracking-[-0.02em] text-platinum">
              {step.title}
            </h3>
            <p className="mt-2.5 text-[13.5px] leading-relaxed text-steel">
              {step.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default FinancingSteps
